import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  tripType: any = "-1";

  constructor(private titleService: Title) {}

  ngOnInit(): void {}

  getTripsList(selectedTripType: any) {
    this.tripType = selectedTripType;
    this.setTitle();
  }

  setTitle() {
    let title = "S9 Trucks | ";
    switch (this.tripType) {
      case "-1":
        title += "Dashboard";
        break;
      case "trucks":
        title += "Trucks";
        break;
      case "trucks-category":
        title += "Truck Category";
        break;
      case "trucks-type":
        title += "Truck Type";
        break;
      case "drivers":
        title += "Drivers";
        break;
      case "mapping":
        title += "Mapping";
        break;
      case "driverOrder":
        title += "Driver Order (Route)";
        break;
      case "tax":
        title += "Tax";
        break;
      case "gps":
        title += "GPS";
        break;
      case "documents":
        title += "Documents";
        break;
      case "trips":
        title += "Trips";
        break;
      case "payments":
        title += "Payments";
        break;
      case "track":
        title += "Track";
        break;
      case "users":
        title += "Users";
        break;
      case "web":
        title += "Web Pages";
        break;
      default:
        title += "Dashboard";
    }

    this.titleService.setTitle(title);
  }
}
